import {AlternativeAutoComplete} from 'common/form/autoComplete/_alternativeAutoComplete'
import {Option} from 'common/form/autoComplete/_option'
import React from 'react'
import {useHistoryOrderFilterForm} from "../../../../hooks/useHistoryOrderFilterForm";

export const UtmSource = () => {
  const {utmSource} = useHistoryOrderFilterForm()
  return (
    <AlternativeAutoComplete
      className="order-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: {name: 'Nguồn đơn hàng', value: ''}, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 130,
        placeholder: 'Chọn nguồn đơn hàng',
        readOnly: true,
        value: utmSource.value?.name || '',
        onIconClick: () => utmSource.onChange(null),
      }}
      bottom={true}
      // search input in dropdown menu
      hideSearchBar={true}
    >
      {utmSource.list.length > 0 &&
        utmSource.list.map(item => (
          <Option
            key={item.value}
            className="order-filter-form__option-text"
            data-active={item.value === utmSource.value?.value}
            onClick={() => utmSource.onChange(item)}
          >
            {item.name}
          </Option>
        ))}
    </AlternativeAutoComplete>
  )
}
